'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (Scroll, $) {
		'use strict';

		/**
    *  Dependency: components/_scroll.scss
    *
    *
    */

		var $dom = {};

		var cacheDom = function cacheDom() {};

		Scroll.lock = function (menuName) {
			$('html, body').addClass('no-scroll');
		};

		Scroll.unlock = function (menuName) {
			$('html, body').removeClass('no-scroll');
		};

		Scroll.toggle = function (menuName) {
			$('html, body').toggleClass('no-scroll');
		};

		var bindUIActions = function bindUIActions() {};

		Scroll.init = function () {
			cacheDom();
		};
	})(window.Scroll = window.Scroll || {}, _jquery2.default);
};